import RegistrarSignUpScreen from './RegistrarSignUpScreen';
export default RegistrarSignUpScreen;
